export default "__VITE_ASSET__CSGyzag2__"